
<template>
    
        <mars-view v-if="showPopup" class="selected-mask" @click.native.stop="closePopupFn" @touchmove.native.stop><mars-view class="popup-content"><mars-view class="popup-top"><mars-view class="titlt">已经到底啦</mars-view><mars-view class="sub">还有疑问建议</mars-view><mars-view class="sub">直接向律师提出问题</mars-view><mars-view class="icon iconfont close close-icon" @click.native.stop="closePopupFn"></mars-view></mars-view><mars-view class="popup-bottom"><mars-view class="popup-bottom-btn" @click.native="clickToAsk">
                立即提问
            </mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
import { ubcClickInit } from '../../../static/utils/ubcMethods';
export default {
  components: {},
  props: {
    showPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    closePopupFn() {
      this.$emit('closePopUp');
    },
    clickToAsk() {
      // 非定向-在线咨询-底部
      ubcClickInit({
        page: 'qalandpage/selected',
        value: 'buttom-pop-consult-click',
        ext: {
          consult_type: 'online-chat'
        }
      });
      this.$emit('turnIm');
    }
  }
};
</script>

<style scoped>
.selected-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 15;
  font-family: PingFangSC-Regular;
}
.selected-mask .popup-content {
  width: 3.3rem;
  height: 3.14rem;
  background: #fff;
  border-radius: 0.13rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  overflow: hidden;
}
.selected-mask .popup-content .popup-top {
  width: 3.3rem;
  height: 2.3rem;
  padding: 0.64rem 0.15rem;
  box-sizing: border-box;
  background: url('https://law-smartapp.cdn.bcebos.com/banner/lvlin-modal.png') no-repeat;
  background-size: 100% 100%;
}
.selected-mask .popup-content .popup-top .titlt {
  font-family: PingFangSC-Medium;
  font-size: 0.24rem;
  color: #fff;
  letter-spacing: 0;
  line-height: 0.24rem;
  font-weight: 500;
  margin-bottom: 0.22rem;
}
.selected-mask .popup-content .popup-top .sub {
  font-size: 0.16rem;
  color: #fff;
  letter-spacing: 0;
  line-height: 0.16rem;
  margin-bottom: 0.11rem;
}
.selected-mask .popup-content .popup-top .close {
  font-size: 0.18rem;
  color: #858585;
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  line-height: 0.18rem;
}
.selected-mask .popup-content .popup-bottom {
  width: 100%;
  height: 0.84rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selected-mask .popup-content .popup-bottom .popup-bottom-btn {
  width: 2.5rem;
  height: 0.44rem;
  background: #445fbb;
  border-radius: 0.22rem;
  font-family: PingFangSC-Medium;
  font-size: 0.16rem;
  color: #fff;
  letter-spacing: 0;
  font-weight: 500;
  text-align: center;
  line-height: 0.44rem;
}

</style>
